import React from "react";
import {Typography} from "@material-ui/core";
import styles from "../styles/BlockCaption.module.css";

const BlockCaption = ({blockProps}) => {
  return blockProps.item && blockProps.item.title && blockProps.item.title.length>0 && <Typography variant={'caption'} className={styles.blockCaption}>{blockProps.item.title}</Typography>;
}

export default BlockCaption;
